export default function PromiseSection() {
  const promises = [
    {
      icon: "💡",
      title: "最先端機器のトータル提案",
      description: "DJI農業ドローン、FJD自動操舵、Farmo水管理など最新機器を中立的に提案。ドローン購入者の約8割が自動操舵も同時導入。お客様の経営課題に最適なソリューションを組み合わせます。"
    },
    {
      icon: "🌱",
      title: "負担軽減と収益向上の両立",
      description: "ただ楽になるだけでなく、浮いた時間で1人当たりの作付面積を増やし収益性を確保。重労働からの解放と「収益アップ」「経営規模拡大」まで見据えた本質的な農業改革を支援します。"
    },
    {
      icon: "🤝",
      title: "次世代への架け橋",
      description: "スマート農業で重労働を軽減し、若い世代が参入しやすい環境づくりを推進。地域農業の持続可能性と次世代への技術継承をサポートします。"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            私たちの3つの約束
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {promises.map((promise, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-4xl mb-6 text-center">{promise.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                {promise.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {promise.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}